// extracted by mini-css-extract-plugin
module.exports = {"recommendedReading":"recommendedReading-module--recommendedReading--1F7kU","text":"recommendedReading-module--text--1yrY1","icon":"recommendedReading-module--icon--1aehD"};